__turbopack_context__.v({
  "actions": "NoOfferCard-module__e71X1a__actions",
  "badge": "NoOfferCard-module__e71X1a__badge",
  "card": "NoOfferCard-module__e71X1a__card",
  "content": "NoOfferCard-module__e71X1a__content",
  "description": "NoOfferCard-module__e71X1a__description",
  "header": "NoOfferCard-module__e71X1a__header",
  "iconContainer": "NoOfferCard-module__e71X1a__iconContainer",
  "title": "NoOfferCard-module__e71X1a__title",
});
